import { render, staticRenderFns } from "./SpecialPriceList_List.vue?vue&type=template&id=38732ef8&"
import script from "./SpecialPriceList_List.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceList_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports